import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import App from './App.vue'
import router from './router'
import { SmartHomePreset } from './primevue-preset'
import { initTheme } from './composables/useTheme'
import './pwa'
import './assets/css/app.css'

initTheme()

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: SmartHomePreset,
    options: {
      darkModeSelector: '.dark',
    },
  },
})
app.mount('#app')
